import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=3fc4d80c&scoped=true&"
import script from "./subscribe.vue?vue&type=script&lang=js&"
export * from "./subscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4d80c",
  null
  
)

export default component.exports